import {Injectable} from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpContext, HttpParams, HttpResponse } from '@angular/common/http';
import {Observable} from 'rxjs';
import {CustomHttpResponse} from '../model/custom-http-response';
import { CACHE_ENABLED } from '../interceptor/cache.interceptor';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  host = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getPublicProduct(page?: number, size?: number, categoryId?: string | null,ingredients?: string[],ingredientFlags?: string[]): Observable<HttpResponse<CustomHttpResponse>> {
    let params = new HttpParams();
    if (page) {
      params = params.append('page', page?.toString() || '0')
    }
    if (size) {
      params = params.append('size', size.toString() || '10')
    }
    if (categoryId) {
      params = params.append('categoryId', categoryId)
    }
    if (ingredients) {
      ingredients.forEach(ing => {
        params = params.append('ingredients', ing);
      });
    }
    if (ingredientFlags) {
      ingredientFlags.forEach(ing => {
        params = params.append('ingredientFlags', ing);
      });
    }
    return this.http.get<CustomHttpResponse>(
      `${this.host}/v1/public/products`,
      {
        observe: 'response', params,
        context: new HttpContext().set(CACHE_ENABLED, true)
      }
    )
  }

  getProductById(id: string): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(
      `${this.host}/v1/public/products/${id}`,
      {
        observe: "response",
        context: new HttpContext().set(CACHE_ENABLED, true)
      }
    )
  }

  getProductBySlug(id: string): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(
      `${this.host}/v1/public/products/slug/${encodeURI(id)}`,
      {
        observe: "response",
        context: new HttpContext().set(CACHE_ENABLED, true)
      }
    )
  }

  getPublicProductFlags(page?: number, size?: number, categoryId?: string | null): Observable<HttpResponse<CustomHttpResponse>> {
    let params = new HttpParams();
    if (page) {
      params = params.append('page', page?.toString() || '0')
    }
    if (size) {
      params = params.append('size', size.toString() || '10')
    }
    if (categoryId) {
      params = params.append('categoryId', categoryId)
    }

    return this.http.get<CustomHttpResponse>(
      `${this.host}/v1/public/products/flags`,
      {
        observe: 'response', params,
        context: new HttpContext().set(CACHE_ENABLED, true)
      }
    )
  }

}
